import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { FadeUp, MaskedLine } from "../components/Reveal";
import { site } from "../data/content";

export default function Contact() {
  return (
    <div className="flex min-h-[80vh] flex-col justify-center pt-32 md:pt-44">
      <div className="mx-auto w-full max-w-7xl px-6 pb-28">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue">
          Contact
        </p>
        <h1 className="mt-6 font-display font-extrabold leading-[0.95] tracking-[-0.03em] text-[clamp(2.8rem,8.5vw,7.5rem)]">
          <MaskedLine delay={0.15}>GOT A PROBLEM THAT</MaskedLine>
          <MaskedLine delay={0.28}>
            <span className="text-blue">WON'T FIT ON A SLIDE?</span>
          </MaskedLine>
        </h1>

        <FadeUp delay={0.35}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-smoke md:text-lg">
            Briefs, problems worth reframing, collaborations, or a conversation about
            emerging markets — the inbox is open.
          </p>
        </FadeUp>

        <div className="mt-14 grid gap-6 md:grid-cols-3">
          <FadeUp delay={0.1}>
            <a
              href={`mailto:${site.email}`}
              data-testid="contact-email-link"
              className="group flex h-full items-center justify-between gap-6 border border-ink p-8 transition-colors duration-300 hover:bg-ink hover:text-paper"
            >
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke group-hover:text-paper/60">
                  Email
                </p>
                <p className="mt-3 break-all font-display text-lg font-bold tracking-tight md:text-xl">
                  {site.email}
                </p>
              </div>
              <Mail size={24} className="shrink-0 transition-transform duration-300 group-hover:-translate-y-1" />
            </a>
          </FadeUp>
          <FadeUp delay={0.15}>
            <a
              href={site.phoneLink}
              data-testid="contact-phone-link"
              className="group flex h-full items-center justify-between gap-6 border border-ink p-8 transition-colors duration-300 hover:bg-ink hover:text-paper"
            >
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke group-hover:text-paper/60">
                  Phone
                </p>
                <p className="mt-3 font-display text-lg font-bold tracking-tight md:text-xl">
                  {site.phone}
                </p>
              </div>
              <Phone size={24} className="shrink-0 transition-transform duration-300 group-hover:-translate-y-1" />
            </a>
          </FadeUp>
          <FadeUp delay={0.2}>
            <a
              href={site.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-linkedin-link"
              className="group flex h-full items-center justify-between gap-6 border border-ink p-8 transition-colors duration-300 hover:bg-blue hover:border-blue hover:text-paper"
            >
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke group-hover:text-paper/60">
                  LinkedIn
                </p>
                <p className="mt-3 break-all font-display text-lg font-bold tracking-tight md:text-xl">
                  {site.linkedinLabel}
                </p>
              </div>
              <ArrowUpRight size={24} className="shrink-0 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </a>
          </FadeUp>
        </div>

        <FadeUp delay={0.3}>
          <p className="mt-12 border-t border-line pt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
            {site.company} · Based in {site.location} · Working across Bharat
          </p>
        </FadeUp>
      </div>
    </div>
  );
}
